const EP_SERVICE_MANAGEMENT_ALLOWED_USER_IDS = new Set([
  '89461579', // berkan.yaman@malllogistics.com
  '25594384402168332392', // deniz.yilmaz@easypoint.com.tr
  '73342538', // erdogan.yilmaz@easypoint.com.tr
  '14122798', // narin.yildiz@malllogistics.com
  '94706995', // oguz.yusufoglu@easypoint.com.tr -> 
  '60357622', // yakup.tari@easypoint.com.tr
  '08767646', // rabia.kepenek@easypoint.com.tr
  '22312037', // esra.ozbas@easypoint.com.tr
]);
const PROGRESS_PAYMENT_ALLOWED_USER_IDS = new Set([
  '21879574870470671135', // Büşra Tokay => Backoffice
  '94706995', // oguz.yusufoglu@easypoint.com.tr -> 
  '22312037', // esra.ozbas@easypoint.com.tr
]);

const getUserId = (user) => {
  if (!user) return '';

  const rawUserId = user.userID || user.userId || user.userid || '';

  return String(rawUserId).trim();
};

export const canAccessEPServiceManagement = (user) => {
  const userId = getUserId(user);
  return EP_SERVICE_MANAGEMENT_ALLOWED_USER_IDS.has(userId);
};
export const canAccessProgressPayment = (user) => {
  const userId = getUserId(user);
  return PROGRESS_PAYMENT_ALLOWED_USER_IDS.has(userId);
};

export const canAccessDHLShipments = (user) => user?.type === 'highadmin';

